<template lang="pug">
v-menu(v-model="menuStatus" :close-on-content-click="false" :eager="true" :z-index="9999")
	template(v-slot:activator="{props}")
		v-text-field(
			v-bind="Object.assign(inputProps, props)"
			:model-value="inputValue"
			@update:model-value="inputUpdate"
			@keydown='onKeyDown($event)'
			append-inner-icon="mdi-menu-down"
			:class="$attrs.class + startFieldClass"
			@click:append-inner="menuStatus = true"
			:rules="dateRule"
			:disabled="disabled"
		)
			template(v-slot:prepend-inner)
				v-icon(icon="mdi-calendar" color="accent" @click='menuStatus = true')

	date-picker(
		:model-value="modelValue"
		@update:model-value="datePickerUpdate($event)"
		mode="date"
		:min-date="minDate"
		:max-date="maxDate"
		v-bind="pickerProps"
		is-required
	)
</template>

<script setup>
import { computed, ref } from 'vue';
import {DatePicker} from 'v-calendar';
import {useI18n} from "vue-i18n";
import { useDialogManagerStore } from '@/stores/dialog-manager';
import { parseBirthdate } from '@/common-scripts/utilities';
import { onBeforeUnmount } from 'vue';
import {useBookingStepperStore} from "@/stores/booking-stepper";

const menuStatus = ref(false);
const i18n = useI18n();
const props = defineProps(['modelValue', 'minDate', 'maxDate', 'pickerProps', 'inputProps', 'defaultDate', 'isRequired', 'isChildrenBirthdate', 'isBirthdate', 'disabled']);
const emit = defineEmits(['update:modelValue']);
const inputValue = computed(() => {
	if(!props.modelValue) return '';
	if(typeof(props.modelValue.toLocaleDateString) != 'function') return;
	return props.modelValue.toLocaleDateString(undefined, {day: '2-digit', month: '2-digit', year:'numeric'});
});
const dialog = useDialogManagerStore();
const dateRule = [
	v => {
		if (!props.isRequired && !props.isChildrenBirthdate && !props.isBirthdate) return true;
		if (props.isRequired == true && !v) return i18n.t("sale.date.required", 'Data obbligatoria.');

		const birthdate = parseBirthdate(v);
		const today = new Date();
		if(birthdate && birthdate.getTime() >= today.getTime()) return i18n.t("rules.birthdate", 'Inserire una data valida');

		return true;
		// non va bene, lasciare libera selezione come su trenitalia e avvertire del ricalcolo se necessario
		/* else if (props.isChildrenBirthdate == true) {
			if (!v) return i18n.t("sale.passenger.birthdate_required", 'Data di nascita obbligatoria.');

			const birthdate = parseBirthdate(v);
			const today = new Date();
			const diff = today.getFullYear() - birthdate.getFullYear();
			if (diff < 0) return i18n.t("sale.passenger.is_not_children", "Felicitazioni per il nascituro ! Gentilmente ricontrollare la data.");
			if (diff >= 12){
				return (async() => {
					const resp = await dialog.openSimpleMessageDialog({
						messageType: 'error',
						title: i18n.t('sale.date.is_not_children', "Il ragazzo ha più di 12 anni, potrebbero NON essere applicate le offerte dedicate ai bambini. Per maggiori informazioni cliccare sul link qui sotto."),
						textHTML: '<a href="' + i18n.t('link.children_policy_link', "https://www.trenitalia.com/it/html/trenitalia/Info_regionale.html") +
						'" target="blank"><b><u><i>' + i18n.t('links.children_policy_title', "Trenitalia: Agevolazioni per i ragazzi") + '</i></u></b></a>'
					});

					return true;

				})().catch(e => {
					console.error('date rules for children', e);
				});
			}
			
			return true;
		} else if (props.isBirthdate == true) {
			if (!v) return true;
			
			const birthdate = parseBirthdate(v);
			const today = new Date();
			const diff = today.getFullYear() - birthdate.getFullYear();
			if (diff < 0) return i18n.t("sale.passenger.is_not_children", "Felicitazioni per il nascituro ! Gentilmente ricontrollare la data.");
			if (diff < 12){
				return (async() => {
					const resp = await dialog.openSimpleMessageDialog({
						messageType: 'error',
						title: i18n.t('sale.date.is_not_adult', "Il passeggero ha segnato una età inferiore ai 12 anni segnandosi però come adulto. Per favore controllare i dati di ricerca e/o la data di nascita immessa."),
					});

					return 'Error';

				})().catch(e => {
					console.error('date rules for adult', e);
				});
			}
			
			return true;
		}*/
	},
];
const startFieldClass = computed(() =>  {
	if (useBookingStepperStore().inSearchPage) return ' start-field';
	return '';
})

onBeforeUnmount(() => {
	menuStatus.value = false;
});


function onKeyDown(event){
	menuStatus.value = false;
}
function datePickerUpdate(event){
	emit('update:modelValue', event);
	menuStatus.value = false;
}
function inputUpdate(dateText){
	if(!dateText){
		emit('update:modelValue', props.defaultDate);
		return;
	}
	const parts = dateText.split('/').map(Number).filter(p => p);
	if(!parts || parts.length != 3) return;

	// TODO: check locale, day/month can change order
	const newDate = new Date(props.modelValue);

	newDate.setDate(parts[0]);
	newDate.setMonth(parts[1] - 1);
	newDate.setFullYear(parts[2]);

	// TODO: show a message when is invalid?
	if(isNaN(newDate)) return;
	if(props.minDate && newDate.getTime() < props.minDate.getTime()) return;
	if(props.maxDate && newDate.getTime() > props.maxDate.getTime()) return;
	emit('update:modelValue', newDate);
}
</script>

<style scoped>
.start-field :deep(.v-field){
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	border-right: 0;
}
</style>